import React, { useState } from 'react';
import cn from 'classnames';

import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';

import { Button, Icons, Typography } from '..';

import styles from './notification.module.scss';

const Notification = ({ className, title, children, ...props }) => {
  const [close, setClose] = useState(false);

  return (
    <div
      className={cn(
        className,
        styles.notification,
        applyClasses(props, styles)
      )}
      style={!close ? {} : { display: 'none' }}
      {...applyProps(props)}
    >
      <Button className={styles.closeButton} onClick={() => setClose(true)}>
        <Icons.NavClose className={styles.closeIcon} />
      </Button>
      {title && (
        <Typography h2 bold>
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
};

Notification.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.any,
};

Notification.defaultProps = {
  className: undefined,
  title: undefined,
  children: undefined,
};

export default Notification;
